<template>
<v-dialog
    v-model="dialog"
    max-width="920"
    v-if="results != null"
>
    <v-card>
        <v-card-title>RedChirp AI: Suggestions To Improve Message Content</v-card-title>

        <v-card-text>
            <m-beta-alert
                code="model-r1"
                dense
            >
                RedChirp AI is a beta feature &mdash; if the AI says anything strange or makes some poor / confusing suggestions please <a style='text-decoration: underline' v-on:click="onClickProvideFeedback">let us know so we can make improvements</a>
            </m-beta-alert>

            <div><b>Original Message</b></div>
            <div 
                class="feedback"
                v-html="$rc.wrapHTML(results.draft_message)"
            />

            <div><b>Forecasted Message Content Sentiment Score</b></div>

            <div 
                class="feedback"
                style="display: flex"
            >

                <div
                    style="flex-grow: 1; padding-top: 5px"
                >
                    {{results.forecast_sentiment_score}}
                </div>

                <div
                    style="flex-grow: 0"
                >
                    <v-chip
                        dense
                        color="red"
                        style="color: white;"
                        label
                        v-if="results.forecast_sentiment_score < 30"
                    >
                        Poor
                    </v-chip>
                    <v-chip
                        dense
                        color="orange"
                        style="color: white;"
                        label
                        v-if="results.forecast_sentiment_score >= 30 && results.forecast_sentiment_score < 60"
                    >
                        Average
                    </v-chip>
                    <v-chip
                        dense
                        color="green"
                        style="color: white;"
                        label
                        v-if="results.forecast_sentiment_score >= 60"
                    >
                        Good
                    </v-chip>
                </div>
            </div>

            <div><b>What is good</b></div>
            <div class="feedback">
                <ul>
                    <li
                        v-for="(item,index) in results.positive_feedback"
                        :key="'pos_'+index"
                    >
                        {{item}}
                    </li>
                </ul>
            </div>

            <div><b>What could use improvement</b></div>
            <div class="feedback">
                <ul>
                    <li
                        v-for="(item,index) in results.negative_feedback"
                        :key="'neg_'+index"
                    >
                        {{item}}
                    </li>
                </ul>
            </div>

            <div style="margin-bottom: 15px"><b>Examples of Improved Messages</b></div>
            <div class="feedback">
                <div
                    v-for="(item,index) in results.improved_messages"
                    :key="'improved_'+index"
                    class="improved_message"
                >
                    <div
                        v-html="$rc.wrapHTML(item)"
                    />

                    <div
                        style="text-align: right; margin-top: 15px"
                    >
                        <v-btn
                            dense
                            small
                            v-on:click="onClickAdopt(item)"
                        >
                            Use This Message
                        </v-btn>
                    </div>
                </div>
            </div>

        </v-card-text>

        <v-card-actions>

             <v-btn
                text
                @click="onClickProvideFeedback"
            >
                Provide Feedback to Help Us Improve the AI
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
                Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            results: null,
        }
    },

    methods: {

        showDialog(results)
        {
            this.results = _.cloneDeep(results);
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
        },

        onCancel()
        {
            this.dialog = false;
        },

        onClickAdopt(message)
        {
            this.$rc.confirm({
                'title': 'Confirm Change Message',
                'body': 'You are about to change your messaage. This can not be undone.',
                'btn_text_ok': 'Change Message',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doAdopt(message);
                },
            });
        },

        doAdopt(message)
        {
            this.$rc.startProcess({
                'type': 'inference-model-r1-adopt-message-content-suggestion',

                'params': {
                    'bulk_message_id': this.$route.params.bulk_message_id,
                    'message': message,
                },

                'title': 'RedChirp AI: Adopting Suggested Message Content',
                'finished_button_text': 'Ok',
                'failed_button_text': 'Ok',
            
                status: (pte) => {
                    switch (pte.state)
                    {
                        case 'failed': return 'Unable to adopt improved message content';
                        case 'finished': return 'Message patterns updated';
                    }

                    return 'Generating message patterns (including alternate version without {first-name})';
                },
            
                on_finished: (pte) => {
                    this.dialog = false;
                    this.$rc.snackbar('Message patterns updated');
                    this.$emit('update');
                },
            
                on_failed: (pte) => {
                    
                },
            
            });
        },

        onClickProvideFeedback()
        {
            this.$rc.prompt({
                'title' : 'Provide Feedback to Help Us Improve RedChirp AI',
                'label' : 'What could the AI have done better to help you optimize this message?',
                'value' : '',
                'after_prompt' : (value) => {
                    this.provideFeedback(value);
                }
            });
        },

        provideFeedback(rc_customer_feedback)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PATCH: /api/v1/model/r1/message-content/set-customer-feedback',
            
                'params' : {
                        'inference_id': this.results.inference_id,
                        'rc_customer_feedback': rc_customer_feedback
                    },
            
                'on_success': (data) => {
                        this.$rc.alert('Thank you for your feedback!', 'Thank you for your feedback -- we will look to incorporate your input into the next generation of RedChirp AI!')
                    },
            
                'on_error': 'Unable to provide feedback on RedChirp AI',
            });
        },

    },
}
</script>

<style lang="scss" scoped>
.feedback
{
    margin-bottom: 15px,
}

.improved_message {
    background-color: rgba(0,0,0,0.05);
    padding: 15px;
    margin-bottom: 15px;
    border: 1px solid rgba(0,0,0,0.1);
}
</style>